import { sendApi } from ".";
import { T_user } from "../model/user";

export type T_userRole = "USER"|"GUEST";



async function loginPw(data?:T_user){
  const response = await sendApi({
    method: "post",
    url: "/auth/loginPw",
    data: {
      ...data,
    },
  });
  return response;
}



async function logout(){
  const response = await sendApi({
    method: "post",
    url: "/auth/logout",
  });
  return response;
}

async function userList(data?:any){
  const response = await sendApi({
    method: "post",
    url: "/user/list",
    data: {
      ...data,
    },
  });
  return response;
}



async function userInsert(data?:any){
  const response = await sendApi({
    method: "post",
    url: "/user/insert",
    data: {
      ...data,
    },
  });
  return response;
}


async function userUpdate(data?:any){
  const response = await sendApi({
    method: "post",
    url: "/user/update",
    data: {
      ...data,
    },
  });
  return response;
}



async function userInfo(data?:any){
  const response = await sendApi({
    method: "post",
    url: "/user/info",
    data: {
      ...data,
    },
  });
  return response;
}

const user = {
 loginPw,
 logout,
 userList,
 userInsert,
 userUpdate,
 userInfo,
};

export default user;
